import {useEffect, useMemo, useRef, useState} from "react";
import FullCalendar from "@fullcalendar/react";
import {Draggable} from "@fullcalendar/interaction";
import {ViewMountArg} from "@fullcalendar/core";

export default function useCalendarInitDestroy() {
    const calendarRef = useRef<FullCalendar | null>(null)
    const [currentViewCalendar, setCurrentViewCalendar] = useState<"timeGridWeek" | "dayGridMonth" | "timeGridDay">("timeGridWeek")
    useEffect(() => {
        return () => {
            const calendarApi = (calendarRef.current as any)?.getApi();
            if (calendarApi) {
                calendarApi.destroy(); // Rimuovi correttamente tutti i listener
            }
        };
    }, []);

    useEffect(() => {
        let draggableInstance: Draggable | undefined;
        if ((!currentViewCalendar || currentViewCalendar === 'timeGridWeek')) {
            const draggableEl = document.getElementById('external-events');

            if (draggableEl) {
                draggableInstance = new Draggable(draggableEl, {
                    itemSelector: '.fc-drag-item',
                    eventData: (eventEl) => {
                        const userId = eventEl.getAttribute('data-user-id');
                        return {
                            title: eventEl.innerText,
                            id: userId
                        };
                    },
                });
            }
        }
        return () => {
            if (draggableInstance) {
                draggableInstance.destroy();
            }
        }
    }, [currentViewCalendar]);
    const isEditable = useMemo(() => {
        return currentViewCalendar === 'timeGridWeek'
    }, [currentViewCalendar])

    return {
        calendarRef,
        currentViewCalendar,
        setCurrentViewCalendar,
        isEditable
    };
}
